<template>
  <img
    ref="image"
    :class="['tkImage', { '-suppressHighlight': suppressHighlight }]"
    :style="[
      height ? { 'height': `${height}px` } : {},
      objectFit ? { 'object-fit': objectFit } : {},
    ]"
    :src="srcImagePath"
    alt=""
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'TkImage',
  components: {},
  props: {
    imagePath: {
      type: String,
      required: true,
    },
    suppressHighlight: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: undefined,
    },
    // object-fit の値を直接指定する
    objectFit: {
      type: String,
      default: undefined,
    },
    // 遅延ロードを行うか
    lazy: {
      type: Boolean,
      default: false,
    },
    // rootMargin の bottom の値
    lazyLoadingMargin: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      srcImagePath: this.lazy
        // 古い Android 端末等では imgタグの src を空文字にしていると
        // 無駄にページリクエストされる場合があるので、ダミーの画像を入れておく
        // また、読み込み前にダミーの画像が無いと height 指定ができないため必要
        ? 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
        : this.imagePath,
    }
  },
  mounted() {
    // 2022 現在、IE や Opera Mini 等を除いてほぼ全てのデバイスで存在するはず
    // 実質、テスト時にスキップするための記述
    if ('IntersectionObserver' in window && this.lazy) {
      const observer = new IntersectionObserver(([image]) => {
        // 設定した領域に入ったら画像をロードする
        // storybookでは現状だと挙動確認できないため、確認できるようにしたい
        if (image.isIntersecting) {
          this.srcImagePath = this.imagePath
          observer.disconnect()
        }
      }, {
        threshold: [0],
        rootMargin: `0px 0px ${this.lazyLoadingMargin}px 0px`,
      })
      observer.observe(this.$refs.image)
    }
  },
}
</script>

<style lang="scss" scoped>
.tkImage {
  &.-suppressHighlight {
    &:hover {
      opacity: 1;
    }
  }
}
</style>
